export default {
  getTrainingItem: (state) => state.trainingItem,
};
